import Inflector from 'ember-inflector';

const { inflector } = Inflector;

inflector.irregular('SMS', 'SMSs');
